import styles from './List.module.scss'
import {AppContext} from "../../../../context/AppContext";
import Button from "../../../elements/Button/Button";
import clsx from "clsx";
import Icon from "../../../elements/Icon/Icon";
import {useContext} from "react";

const List = ({handleInvoiceChange, formState, setFormState}) => {
    const {windowWidth} = useContext(AppContext);
    const items = formState.items;
    const errors = []
    const isDesktop = windowWidth >= 768;

    const handleItemsAdd = () => {
        setFormState({
            ...formState,
            items: [
                ...items,
                {
                    name: '',
                    quantity: '1',
                    price: '',
                    total: 0,
                },
            ],
        });
    };

    const handleItemsRemove = (index) => {
        const newItems = items.filter((_, i) => i !== index);
        setFormState({
            ...formState,
            items: newItems,
        });
    };

    return (
        <fieldset className={styles.fieldset}>
            <legend className={styles.legend}>Item List</legend>
            <div className={styles.wrapper}>
                {items?.filter(Boolean).map((item, index) => (
                    <div className={styles.inputGroup} key={index}>
                        <div className={styles.inputContainer}>
                            <label
                                className={clsx(styles.label, {
                                    [styles.srOnly]: index > 0 && isDesktop,
                                    [styles.error]: errors[index]?.name,
                                })}
                                htmlFor="name"
                            >
                                Item Name
                                {errors[index]?.name && (
                                    <span className={styles.error}>can't be empty</span>
                                )}
                            </label>
                            <input
                                className={clsx(styles.input, {
                                    [styles.error]: errors[index]?.name,
                                })}
                                type="text"
                                name="name"
                                value={item.name}
                                onChange={(event) =>
                                    handleInvoiceChange(
                                        event,
                                        'items',
                                        null,
                                        index
                                    )
                                }
                            />
                        </div>
                        <div className={styles.inputContainer}>
                            <label
                                className={clsx(styles.label, {
                                    [styles.srOnly]: index > 0 && isDesktop,
                                    [styles.error]: errors[index]?.name,
                                })}
                                htmlFor="quantity"
                            >
                                Qty.
                            </label>
                            <input
                                className={clsx(styles.input, {
                                    [styles.error]: errors[index]?.quantity,
                                })}
                                type="text"
                                name="quantity"
                                value={item.quantity}
                                onChange={(event) =>
                                    handleInvoiceChange(
                                        event,
                                        'items',
                                        null,
                                        index
                                    )
                                }
                            />
                        </div>
                        <div className={styles.inputContainer}>
                            <label
                                className={clsx(styles.label, {
                                    [styles.srOnly]: index > 0 && isDesktop,
                                    [styles.error]: errors[index]?.price,
                                })}
                                htmlFor="price"
                            >
                                Price
                            </label>
                            <input
                                className={clsx(styles.input, {
                                    [styles.error]: errors[index]?.price,
                                })}
                                type="text"
                                name="price"
                                value={item.price}
                                onChange={(event) =>
                                    handleInvoiceChange(
                                        event,
                                        'items',
                                        null,
                                        index
                                    )
                                }
                            />
                        </div>
                        <div className={styles.inputContainer}>
                            <label
                                className={clsx(styles.label, {
                                    [styles.srOnly]: index > 0 && isDesktop,
                                })}
                            >
                                Total
                            </label>
                            <span className={styles.totalValue}>{item.total}</span>
                        </div>
                        <Button
                            className={styles.deleteBtn}
                            type="button"
                            onClick={() => handleItemsRemove(index)}
                        >
                            <Icon
                                name="delete"
                                size={16}
                                color={'#DFDFDF'}
                            />
                        </Button>
                    </div>
                ))}
                <Button className={styles.secondary} type="button" onClick={handleItemsAdd}>
                    + Add New Item
                </Button>
            </div>
        </fieldset>
    );
};

export default List;
